<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gbZjGr/Images/cover.jpeg?1684274656546" alt="This image is the cover for the book Tempted"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tempted
      </h1>
      <p class="bookDescription body article font2">
        <p>Widowed at thirty-three with two small kids, Beverly Simpson wants someone to blame. Angry, hurt, and full of regret for what she's lost, she rails against a once trusted God and hides her loneliness behind a sassy exterior.<br/><br/>Joe Clark, intrigued by Bev’s irreverent approach to life, stubbornly pursues her. However, the pair have two very different outlooks on life. Joe is a dedicated preacher, while Bev insists she no longer even believes in God. Despite being polar opposites, they can’t hide their attraction to each other, but reconciling their beliefs may be harder than they imagined. Will faith and love be enough to mend a damaged heart?<br/><br/>Originally published in 1987, TEMPTED is an inspiring story of betrayal and trust that will refresh listeners.<br/><br/>Robyn Carr is the #1 New York Times bestselling author of the Virgin River novels and the Thunder Point series.<br/><br/>“Terrific! I love Robyn Carr’s work. She makes you cry, she makes you laugh, she makes you care, and TEMPTED is one of her very best.” --Danielle Steel</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robyn Carr
      </h2>
      
      <p class="authorDescription body article">Robyn Carr is a RITA® Award-winning, #1 New York Times bestselling author of almost fifty novels, including the critically acclaimed Virgin River series. Her highly anticipated new series, Thunder Point, will be released March 2013. Robyn and her husband live in Las Vegas, Nevada. You can visit Robyn Carr's website at www.RobynCarr.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d74cef6